import { DateTime } from "luxon";
import { AccountDetail } from "./accountDetail";
import { Entity } from "./entity";
import { StrategyConfiguration, StrategySegment } from "./StrategyConfiguration";
import { AccountLink } from "./accountLink";


export interface Account extends Entity {
    name: string;
    startDate: DateTime;
    baseCurrency?: string;
    strategyConfiguration: StrategyConfiguration;
    /** Configurations used before each strategy change, oldest first. Server-owned. */
    strategyHistory?: StrategySegment[];
    details: AccountDetail;
    lastAnalysisDate?: Date;
    accountLink?: AccountLink;
    enabled: boolean;
    /** Set by the server when the account is closed. Closed accounts are read-only and final. */
    closedOn?: string | null;
}

export const isClosed = (account: Pick<Account, 'closedOn'>): boolean => !!account.closedOn;
